import React from "react";
import PropTypes from "prop-types";
import WebConfig from "middlewares/WebConfig";
import { Button } from "react-md/lib/Buttons";
import { MSpinner, MSelect } from "components/Shared";
import DialogContainer from "react-md/lib/Dialogs";
import {connect} from "react-redux";
import { get360Value } from "actions/qualityAssurance";

class ThreeSixtyValue extends React.Component {

    constructor(props) {
        super(props);
        this.buildSourceURL = this.buildSourceURL.bind(this);
        this.reload = this.reload.bind(this);
        this.initialReload = this.initialReload.bind(this);
        this.getKey = this.getKey.bind(this);
        this.getCalcOptions = this.getCalcOptions.bind(this);
        this.getDialogOptions = this.getDialogOptions.bind(this);
        this.state = {
            Reload: false,
            initialReload: false,
            newCalc360ValueType: null,
            displayCalcTypeOptions: false,
            startCalcTypeOptions: false,
            startButtonClicked: false,
        };
    }

    componentDidMount() {
        this.props.get360Value(this.props.controlNumber);
    }

    buildSourceURL() {
        const { pageName, controlNumber, calc360ValueTypeCode, formNumber, token } = this.props;
        const { orthosRoot, ssoTokenName } = WebConfig;
        let calcType = this.state.newCalc360ValueType ?? calc360ValueTypeCode;
        return `${orthosRoot}/${pageName}?ControlIDNumber=${controlNumber}&formNumber=${formNumber}&Calc360ValueTypesCode=${calcType}&lPopup=0&StartOver=${this.state.Reload}&${ssoTokenName}=${encodeURIComponent(token)}`;
    }

    initialReload() {
        const { initialReload, Reload } = this.state;
        if (!initialReload) {
            this.setState({
                initialReload: !initialReload,
            });
        }
        if(Reload){
            this.setState({Reload: false, newCalc360ValueType: null});
        }
    } 

    reload() {
        this.setState({Reload: true, displayCalcTypeOptions: false});
    }

    getKey() {
        return `${this.state.initialReload}`;
    }

    startNewCalc() {
        this.setState({Reload: true, startCalcTypeOptions: false, startButtonClicked: true});
    }

    getCalcOptions() {
        return [
            {value: "RESIDENTIAL", label: "Residential"},
            {value: "COMMERCIAL", label: "Commercial"},
            {value: "MANUFACTURED", label: "Manufactured"},
            {value: "CONDO_IU", label: "Condo"},
            {value: "AGRICULTURAL", label: "Agricultural"},
        ];
    }

    getDialogOptions(){
        return [
            <Button
              className="m-t-10"
              key="continue"
              raised
              primary
              disabled={this.state.newCalc360ValueType === null}
              onClick={() => this.reload()}
            >
              Continue
            </Button>,
            <Button
              className="m-t-10"
              key="cancel"
              raised
              primary
              onClick={() => this.setState({displayCalcTypeOptions: false, newCalc360ValueType: null})}
            >
              Cancel
            </Button>
          ];
    }

    startCalcDialogOptions(){
        return [
            <Button
              className="m-t-10"
              key="start"
              raised
              primary
              disabled={this.state.newCalc360ValueType === null}
              onClick={() => this.startNewCalc()}
            >
              Start
            </Button>,
            <Button
              className="m-t-10"
              key="cancel"
              raised
              primary
              onClick={() => this.setState({startCalcTypeOptions: false, newCalc360ValueType: null})}
            >
              Cancel
            </Button>
          ];
    }

    render() {
        const { className, isFetching360 } = this.props;
        if(isFetching360)
            return (<MSpinner />);
        else
            return (
            
            <div className={className}>
                {(this.state.startButtonClicked || this.props.value360?.hasValue) ? (<><Button
                        primary
                        raised
                        onClick={() => this.setState({displayCalcTypeOptions: true})}
                        children="Start Over"
                    />
                    <iframe
                        key={this.getKey()}
                        className="three-sixty-value-legacy-frame"
                        src={this.buildSourceURL()}
                        onLoad={this.initialReload}
                    />
                    </>
                ) : (<Button
                        primary
                        raised
                        onClick={() => this.setState({startCalcTypeOptions: true})}
                        children="Start"
                    />)}
            
                
                    
                <div id="choose-calc-type-container">
                    <DialogContainer
                        id="dialog-choose-calc-type"
                        className="dialog-choose-calc-type"
                        visible={this.state.displayCalcTypeOptions}
                        title="Reset 360Value Calculation"
                        modal
                        width={500}
                        actions={this.getDialogOptions()}
                        >
                        <MSelect
                            id="selectCalcType"
                            placeholder="Please select a Calcuation Type..."
                            options={this.getCalcOptions()}
                            onChange={option => this.setState({newCalc360ValueType: option.value})}
                            name="360Value Calculation Type:"
                            className="md-full-width"
                            getMenuPortalTarget={() => document.querySelector(".dialog-choose-calc-type")}
                        />
                        </DialogContainer>
                        <DialogContainer
                            id="dialog-resetting-calc"
                            visible={this.state.Reload}
                            modal
                            title="Resetting Calculation..."
                            focusOnMount={false}
                            width={400}
                        >
                        <MSpinner />
                    </DialogContainer>
                </div>
                <div id="start-calc-type-container">
                    <DialogContainer
                        id="dialog-start-calc"
                        className="dialog-choose-calc-type"
                        visible={this.state.startCalcTypeOptions}
                        title="Set 360Value Calculation"
                        modal
                        width={500}
                        actions={this.startCalcDialogOptions()}
                        sub
                        >
                        <MSelect
                            id="selectCalcType"
                            placeholder="Please select a Calcuation Type..."
                            options={this.getCalcOptions()}
                            onChange={option => this.setState({newCalc360ValueType: option.value})}
                            name="360Value Calculation Type:"
                            className="md-full-width"
                            getMenuPortalTarget={() => document.querySelector(".dialog-choose-calc-type")}
                            
                        />
                        </DialogContainer>
                        <DialogContainer
                            id="dialog-setting-calc"
                            visible={this.state.Reload}
                            modal
                            title="Setting Calculation..."
                            focusOnMount={false}
                            width={400}
                        >
                        <MSpinner />
                    </DialogContainer>
                </div>
            </div>
        );
    }
}

ThreeSixtyValue.defaultProps = {
    controlNumber: 0,
    calc360ValueTypeCode: "RESIDENTIAL",
    formNumber: 1,
    pageName: "InspectorApp/Calcs/360Value/360Value.aspx",
    className: ""
};

ThreeSixtyValue.propTypes = {
    controlNumber: PropTypes.number,
    calc360ValueTypeCode: PropTypes.string,
    formNumber: PropTypes.number,
    pageName: PropTypes.string,
    className: PropTypes.string,
    token: PropTypes.string,
    value360: PropTypes.object,
    get360Value: PropTypes.func,
    isFetching360: PropTypes.bool,
};

const mapStateToProps = state => ({
  token: state.user.profile.token,
  value360: state.qualityAssurance.value360,
  isFetching360: state.qualityAssurance.isFetching360,
});

const mapDispatchToProps = dispatch => ({
  get360Value(controlNumber) {
    dispatch(get360Value(controlNumber));
  },
});

export default connect(
    mapStateToProps, mapDispatchToProps
)(ThreeSixtyValue);

